import { TEMPLATE_MAX_LENGTH } from "./constants";

export const isPlainTextValid = (plainText: string): boolean =>
  !!(plainText && plainText.includes("{{message.text}}") && plainText.length <= TEMPLATE_MAX_LENGTH);

export const isHTMLValid = (html: string): boolean =>
  !!(
    html &&
    html.includes("{{{message.html}}}") &&
    html.match(/<body[\s\S]*>/gim) !== null &&
    html.match(/<\/\s*body\s*>/gim) !== null &&
    html.length <= TEMPLATE_MAX_LENGTH
  );
